import { Space, Tooltip } from "antd";
import { ReactNode } from "react";
import IMG from "../../assets/images/avatar.svg";

interface EmployeeInfoItemProps {
  img?: string;
  name?: string | null;
  id?: string | number | null;
  designation?: string;
  department?: string;
  email?: string;
  align?: "start" | "end" | "center" | "baseline";
  children?: ReactNode;
  imgClassName?: string;
}

export default function EmployeeInfoItem({
  img = IMG,
  name,
  id,
  designation,
  department,
  email,
  align = "center",
  children,
  imgClassName = "",
}: EmployeeInfoItemProps) {
  return (
    <Space align={align} className="w-full" size={16}>
      <div className={`w-24 h-24 ${imgClassName}`}>
        <img className="w-full h-full rounded-full" src={img} alt="" />
      </div>
      <div className="flex flex-col gap-0.5">
        <h3 className="text-body text-lg font-semibold leading-normal">
          {name || "Name: n/a"}
        </h3>
        <p className="text-extra-gray text-sm font-medium leading-normal">
          ID: {id || "n/a"}
        </p>
        <p className="text-display-body text-sm font-medium leading-normal">
          {designation || "Designation: n/a"}
        </p>
        {department && (
          <p className="text-display-body text-sm font-medium leading-normal">
            Department of
            <span className="text-tint-warning ml-1.5">
              {department || "n/a"}
            </span>
          </p>
        )}
        {/* <p className="text-display-body text-sm font-medium leading-normal">
          Email:
          <a
            href={`mailto:${email}`}
            className="!text-accent hover:underline ml-1.5"
          >
            {email || "n/a"}
          </a>
        </p> */}

        {/* Email in a single line with ellipsis */}
        <p className="text-display-body text-sm font-medium leading-normal flex items-center">
          Email:{" "}
          <Tooltip title={email || "n/a"}>
            <a
              className="text-accent ml-1.5 hover:underline truncate overflow-hidden inline-block align-middle max-w-[150px] whitespace-nowrap"
              href={`mailto:${email}`}
            >
              {email || "n/a"}
            </a>
          </Tooltip>
        </p>
        {children}
      </div>
    </Space>
  );
}
